import {
  Box,
  Typography,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
} from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';
import IllustrationWrapper from '../../../../v3/Illustrration/IllustrationWrapper';
import DisclaimerSvg from '../../../../v3/Illustrration/components/DisclaimerSvg';
import { CustomButton } from '../../../MUI_custom_component';

export default function AgeWarningModal({ updateRelation, showAgeModal, close, callBloodRelationAPI, owner_type_text }) {
  const userData = useSelector(state => state.user?.userData);

  const handleEditPanClick = () => {
    trackAnalyticsEvent('BENEFICIARY_AGE_WARNING_EDIT_PAN_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      action: 'edit_pan'
    });
    close();
  };

  const handleSelectBloodRelativesClick = () => {
    trackAnalyticsEvent('BENEFICIARY_AGE_WARNING_BLOOD_RELATIVES_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      action: 'select_blood_relatives',
      owner_type: owner_type_text?.value || ''
    });
    callBloodRelationAPI(owner_type_text.value);
  };

  return (
    <Dialog 
        open={showAgeModal} 
        onClose={close} 
        PaperProps={{
            sx: { borderRadius: 3,
            width:"350px" }
        }}
    >
        <DialogContent sx={{ p: 2 }} >
            <Box sx={{ textAlign: 'center'}}>
                <IllustrationWrapper 
                  illustration={<DisclaimerSvg />}
                  title="Age > 60 years"
                  subtitle="Please select from below"
                />
            </Box>
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
          {!updateRelation && (
              <CustomButton
                variant="filled"
                color="primary"
                label="Select Blood Relatives"
                onClick={handleSelectBloodRelativesClick}
              />
            )}
            <CustomButton
                variant="outlined"
                color="primary"
                label="Edit PAN"
                onClick={handleEditPanClick}
              />
        </Box>
    </Dialog>
  );
}
